export default __webpack_public_path__ + "static/media/180px-Sunset-Title-PMR-light-border.a1e793ec.webp";